export default "__VITE_ASSET__Dj95mojN__"